/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {environment} from '../../../environments/environment';
import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {MaterialDetailModel} from './contracts/material-detail.model';
import {ValidationResultModel} from '../generic/contracts/validation-result.model';

@Injectable({
    providedIn: 'root'
})
export class MaterialApi {
    private materialsBaseUrl = `${environment.claimsBaseUrl}/api/material`;
    private materialsDetailUrl = `${this.materialsBaseUrl}/detail`;

    constructor(private http: HttpClient) {
    }

    getMaterials(query: string,
                 supplyingPackingPlantCode: string,
                 firstResult: number,
                 maxResults: number): Observable<MaterialDetailModel[]> {
        return this.http.get<MaterialDetailModel[]>(`${this.materialsDetailUrl}?` + [
            `numberOrDescription=${query}`,
            `firstResult=${firstResult}`,
            `maxResults=${maxResults}`,
            `supplyingPackingPlantCode=${supplyingPackingPlantCode}`
        ].join('&'));
    }

    getAutoCompleteMaterials(query: string,
                             supplyingPackingPlantCode: string): Observable<MaterialDetailModel[]> {
        return this.getMaterials(query, supplyingPackingPlantCode, 0, 20);
    }

    validateMaterial(materialNumber: string, supplyingPackingPlantCode: string): Observable<ValidationResultModel> {
        return this.http.get<ValidationResultModel>
            (`${this.materialsBaseUrl}/${materialNumber}/validate?supplyingPackingPlantCode=${supplyingPackingPlantCode}`);
    }
}
